module.exports = __webpack_public_path__ + "img/no-notif.39cf27df.png";